export const getWebsiteNameFromURL = (inputUrl: string) => {
  try {
    // Ensure URL has protocol
    const normalizedUrl = inputUrl.startsWith("http")
      ? inputUrl
      : `https://${inputUrl}`;

    const { hostname } = new URL(normalizedUrl);
    // Remove common subdomains
    const parts = hostname.replace(/^www\./, "").split(".");
    // Handle cases like linkedin.com, instagram.com
    let name = parts.length > 2 ? parts[parts.length - 2] : parts[0];
    // Fallback: ensure minimum length
    if (name.length < 2) {
      name = parts.find((p) => p.length >= 2) || "";
    }
    // Capitalize
    return name ? name.charAt(0).toUpperCase() + name.slice(1) : "Custom name";
  } catch {
    return "Custom name";
  }
};
